import getDB from './util/getDB';

export const offlineTaskIsPristine = getDB<boolean>('OfflineTaskIsPristine', 1, 'taskIsPristine');
